import { styled } from 'stitches.config'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'

export const HeroRoot = styled('div', {
  flex: 1,
  background: '$tertiary-200',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  overflow: 'hidden',

  '& .desktop-only': {
    display: 'none',
  },

  '& .mobile-only': {
    display: 'block',
  },

  '@bp2': {
    display: 'block',
    '& .desktop-only': {
      display: 'block',
    },

    '& .mobile-only': {
      display: 'none',
    },
  },
  '.cta': {
    display: 'none',

    '@bp2': {
      cursor: 'pointer',
      display: 'inline-flex',
    },
  },
})

export const HeroContent = styled('div', {
  width: '100%',
  order: 1,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  paddingBottom: '100px',

  '@bp2': {
    paddingBottom: '0px',
    width: '50%',
  },

  variants: {
    order: {
      '0': {},
      '1': {
        paddingBottom: '0px',
      }
    }
  }
})

export const HeroHeader = styled('div', {
  paddingTop: '$3',
  paddingBottom: '$4',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '$2',
  '@bp3': {
    paddingBottom: '$5',
  },

  variants: {
    order: {
      '0': {},
      '1': {
        paddingTop: '$9',
        paddingBottom: '$7',
        '@bp2': {
          paddingBottom: '$5',
          paddingTop: '$2'
        },
        '@bp4': {
          paddingTop: '$5',
        }
      },
    }
  }
})

export const ImageWrapper = styled('div', {
  position: 'relative',
  width: '100%',
  fontSize: 0,
  lineHeight: 0,
  textAlign: 'center',
  '@bp2': {
    width: '50%',
    textAlign: 'left',
  },

  variants: {
    order: {
      '0': {},
      '1': {
        '@bp2': {
          width: '50%',
          minHeight: '600px',
        },
        '@bp3': {
          minHeight: 'none',
        }
      }
    }
  }
})

export const BadgeContainer = styled('div', {
  position: 'absolute',
  top: '-50px',
  left: 0,
  zIndex: 1,
  right: 0,
  margin: 'auto',
  color: '$primary-500',
  size: '100px',

  '@bp2': {
    top: '200px',
  },

  '@bp3': {
    position: 'relative',
    size: '140px',
    top: 'unset',
    right: 'unset',
    left: 'unset',
  },

  '@bp4': {
    size: '160px',
  },

  variants: {
    order: {
      '0': {},
      '1': {
         top: 'unset',
         bottom: '-50px',
         size: '100px',
         '@bp3': {
          size: '0px',
         },
         '@bp4': {
          size: '160px',
          top: 0,
         }
      },
    },
  },
})

export const IconContainer = styled('div', {
  position: 'relative',

  variants: {
    type: {
      antibiotics: {
        size: '80px',
        '@bp2': {
          size: '60px',
        },
        '@bp3': {
          size: '70px',
          marginBottom: '-6px',
        },
        '@bp4': {
          size: '90px',
        },
      },
      filler: {
        size: '105px',
        marginBottom: '-16px',
        '@bp2': {
          size: '85px',
          marginBottom: '-12px',
        },
        '@bp3': {
          size: '85px',
          marginBottom: '-12px',
        },
        '@bp4': {
          size: '115px',
          marginBottom: '-14px',
        },
      },
      humanely: {
        size: '80px',
        '@bp2': {
          size: '60px',
        },
        '@bp3': {
          size: '70px',
          marginBottom: '-6px',
        },
        '@bp4': {
          size: '90px',
        },
      },
      preservatives: {
        size: '70px',
        '@bp2': {
          size: '60px',
        },
        '@bp3': {
          size: '60px',
        },
        '@bp4': {
          size: '80px',
        },
      },
    },
  },
})

export const HeroContainer = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  margin: 'auto',
  alignItems: 'center',
  flexDirection: 'column-reverse',
  maxWidth: '420px',
  '@bp2': {
    flexDirection: 'row',
    maxWidth: '1920px',
  },

  variants: {
    order: {
      '0': {

      },
      '1': {
        flexDirection: 'column',
        position: 'relative',
        alignItems: 'center',
        '@bp2': {
          flexDirection: 'row',
          alignItems: 'flex-start',
        },
        '@bp3_1': {
          alignItems: 'center',
        },
      },
    },
  },
})

export const FeatureColumn = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-end',
  width: '50%',
  height: '200px',
  gap: '$2',

  '@bp3': {
    height: '200px',
    width: '140px',
    gap: '$3',
  },

  '@bp4': {
    height: '230px',
  },

  variants: {
    order: {
      '0': {},
      '1': {
        height: '170px',
        '@bp3_1': { height: '200px' },
        '@bp4': { height: '230px' },
      }
    }
  }
})

export const FeatureRow = styled('div', {
  display: 'none',
  justifyContent: 'center',
  width: '100%',
  maxWidth: '958px',
  gap: '$2',
  '@bp2': {
    display: 'flex',
    gap: '$1',
  },

  '@bp3': {
    gap: '$2',
  },

  '@bp4': {
    gap: '$6',
  },
})

export const SectionTitle = styled('h1', {
  fontSize: '$h1',
  fontWeight: '600 !important',
  color: '$primary-500',
  textAlign: 'center',
  maxWidth: '320px',
  lineHeight: '1.0',

  '@bp2': {
    width: '100%',
    maxWidth: 'none',
  },

  '@bp3': {
    fontSize: '$h1',
  },

  '@bp4': {
    fontSize: '90px',
  },
})

export const SectionSubtitle = styled(Text, {
  margin: 'auto',
  maxWidth: '313px',
  '@bp3': {
    maxWidth: 'none',
    width: '450px',
  },
  '@bp4': {
    width: '580px',
  },
})

export const MobileFeatures = styled('div', {
  display: 'flex',
  padding: '0px 24px 48px 24px',
  maxWidth: '420px',
  margin: 'auto',
  flexWrap: 'wrap',
  flexDirection: 'row',
  '@bp2': {
    display: 'none',
  },
})
